import { type Directive } from "vue";
import { gsap } from "gsap";

const defaultOpts = { activeClass: "active", defaultHeight: "100px", duration: 0.3, trigger: "data-expand-trigger" };

export const vExpand: Directive = {
    mounted(el: HTMLUListElement, { value }) {
        if (!process.client) return;

        const opts: typeof defaultOpts = value || { ...defaultOpts };

        // 打开的时候添加的类名
        const activeName = opts.activeClass || defaultOpts.activeClass;
        // 默认的元素高度
        const defaultHeight = opts.defaultHeight || defaultOpts.defaultHeight;
        // 执行动画时间
        const duration = opts.duration || defaultOpts.duration;

        // 展开触发器
        const triggerId = opts.trigger || defaultOpts.trigger;

        //
        const target = el; // el.querySelector("[data-expand-body]"); // el.children.item(1);
        // trigger animation
        const trigger = el.querySelector(`[${triggerId || "data-expand-trigger"}]`) || target;

        if (!target) throw new Error("target undefined");
        let currentAnimation: gsap.core.Tween | null = null;
        function expand() {
            // dom add active classs
            el.classList.add(activeName);
            // animation h 0->full
            const height = target!.scrollHeight;
            currentAnimation = gsap.fromTo(
                target,
                { height: defaultHeight },
                {
                    height: height || "auto",
                    duration: duration,
                    // onUpdate(scope) {
                    //     console.log(this.vars);
                    // },
                }
            );
        }
        function destory() {
            // dom remove active class
            el.classList.remove(activeName);
            // animation reverse
            currentAnimation?.reverse();
            currentAnimation = null;
        }
        trigger.addEventListener("click", () => {
            // if animation in stage active
            // anmation will be destory
            if (currentAnimation) {
                destory();
                return;
            }
            expand();
        });

        // el.addEventListener("mouseleave", () => {
        //     destory();
        // });
    },
};

export default vExpand;
